import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../../services/store';
import { DISPLAY_VERSION } from '../../config/version';

export const Footer: React.FC<{ isCollapsed?: boolean }> = ({ isCollapsed = false }) => {
  const { t } = useApp();
  const year = new Date().getFullYear();

  return (
    <footer className={`relative lg:fixed lg:bottom-0 ${isCollapsed ? 'lg:left-20' : 'lg:left-64'} lg:right-0 bg-white dark:bg-gray-900 border-t lg:border-t-0 border-gray-200 dark:border-gray-700 py-2 px-4 transition-colors z-30`}>
      <div className="flex flex-col sm:flex-row justify-between items-center text-xs text-gray-500 dark:text-gray-400">
        <div className="mb-1 sm:mb-0">
          {t.footer.copyright.replace('{year}', year.toString())}
        </div>
        <div className="flex gap-4">
           <Link to="/impressum" className="hover:text-gray-900 dark:hover:text-gray-200 transition-colors">{t.footer.impressum}</Link>
           <Link to="/datenschutz" className="hover:text-gray-900 dark:hover:text-gray-200 transition-colors">{t.footer.privacy}</Link>
           <Link to="/changelogs" className="hover:text-gray-900 dark:hover:text-gray-200 transition-colors">{t.footer.changelog}</Link>
           <span className="text-gray-400 dark:text-gray-600">{DISPLAY_VERSION}</span>
        </div>
      </div>
    </footer>
  );
};